import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-msg',
    templateUrl: './msg.component.html',
    styleUrls: ['./msg.component.css'],
    providers: [MessageService]
})
export class MsgComponent implements OnChanges {

    @Input()
    tipoMsg = 'info';

    @Input()
    tituloMsg = 'Información';

    @Input()
    detalleMsg = '';

    @Input()
    showMsg = false;

    @Input()
    life = 4000;

    icon: string;

    constructor(private messageService: MessageService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        // console.log('changes ', changes);
        if (this.showMsg) {

            if (this.tipoMsg === 'info') {
                this.icon = 'pi-info-circle';
            } else if (this.tipoMsg === 'warn') {
                this.icon = 'pi-exclamation-triangle';
            } else if (this.tipoMsg === 'error') {
                this.icon = 'pi-times-circle';
            } else if (this.tipoMsg === 'success') {
                this.icon = 'pi-check';
            } else {
                this.icon = 'pi-info-circle';
            }

            this.messageService.add({ key: 'tst', life: this.life,
            severity: this.tipoMsg, summary: this.tituloMsg, detail: this.detalleMsg });
            this.showMsg = false;
        }
    }

}
